export default __webpack_public_path__ + "static/blaze-3182feabb2c42dbfa8d4d4bf037d9afb.png";